// LICENSE : MIT
"use strict";
export class AppLocator {
    constructor() {
        /**
         * @type {Context}
         */
        this.context = null;
    }
}

export default new AppLocator();



// WEBPACK FOOTER //
// ./src/AppLocator.js